// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Wh4o","top":"styles_top__EfsdY","left":"styles_left__3GEwo","description":"styles_description__-bprg"};